@if (chatUrl) {
  <a
    class="navigation-header-chat__link"
    [href]="chatUrl"
    target="_blank"
    rel="noopener"
    [attr.aria-label]="ariaLabel"
    [ngfBadge]="displayCount"
    [ngfBadgeHidden]="!hasUnreadMessages">
    <img src="assets/images/icons/message-text-square-01.svg" alt="" aria-hidden="true" width="24" height="24" />
  </a>
}
